import { render } from "./modifyCommentModal.vue?vue&type=template&id=4f832be1&scoped=true"
import script from "./modifyCommentModal.vue?vue&type=script&lang=js"
export * from "./modifyCommentModal.vue?vue&type=script&lang=js"

import "./modifyCommentModal.vue?vue&type=style&index=0&id=4f832be1&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f832be1"]])

export default __exports__